export default [
  // 宿舍全量
  {
    path: '/dorm/index',
    name: 'PageDormIndexNew',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormIndexNew'
      ),
    meta: { modular: 4, title: '学生宿舍', info: '学生宿舍——首页' }
  },
  {
    path: '/dorm/detail',
    name: 'PageDormDetailNew',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormDetailNew'
      ),
    meta: { modular: 4, title: '学生宿舍', info: '学生宿舍——详情' }
  },
  {
    path: '/dorm/setting',
    name: 'PageDormSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormSetting'
      ),
    meta: { modular: 4, title: '设置', info: '学生宿舍——设置' }
  },
  {
    path: '/dorm/setting/list',
    name: 'PageDormSettingModel',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormSettingModel'
      ),
    meta: { modular: 4, title: '宿舍考勤组', info: '学生宿舍——考勤组' }
  },
  {
    path: '/dorm/setting/save',
    name: 'PageDormGroupSave',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormGroupSave'
      ),
    meta: { modular: 4, title: '学生宿舍', info: '学生宿舍——编辑设置' }
  },
  {
    path: '/dorm/setting/timeStage',
    name: 'PageDormSettingTimeStage',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormSettingTimeStage'
      ),
    meta: { modular: 4, title: '打卡时段', info: '学生宿舍——打卡时段' }
  },
  {
    path: '/dorm/monthly/calendar',
    name: 'PageDormMonthlyCalendar',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormMonthlyCalendar'
      ),
    meta: { modular: 4, title: '考勤记录', info: '学生宿舍——考勤记录' }
  },
  {
    path: '/dorm/setting/dateRules',
    name: 'PageDormSettingDateRules',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormSettingDateRules'
      ),
    meta: { modular: 4, title: '打卡规则', info: '学生宿舍——打卡规则' }
  },
  {
    path: '/dorm/normal/list',
    name: 'PageDormNormalList',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormNormalList'
      ),
    meta: { modular: 4, title: '学生宿舍', info: '学生宿舍——已归寝/已离寝列表' }
  },
  {
    path: '/dorm/setting/more',
    name: 'PageDormMoreSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormMoreSetting'
      ),
    meta: { modular: 4, title: '更多设置', info: '学生宿舍——更多' }
  },
  {
    path: '/dorm/setting/specialDate',
    name: 'PageDormSpecialSetting',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormSpecialSetting'
      ),
    meta: {
      modular: 4,
      title: '特殊日期',
      info: '学生宿舍——特殊日期',
      keepAlive: true
    }
  },
  {
    path: '/dorm/notice',
    name: 'PageDormNotice',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormNotice'
      ),
    meta: { modular: 4, title: '通知配置', info: '学生宿舍——通知配置' }
  },
  {
    path: '/dorm/noticeDetail',
    name: 'PageDormNoticeDetail',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormNoticeDetail'
      ),
    meta: { modular: 4, title: '学生宿舍', info: '学生宿舍——编辑通知设置' }
  },
  {
    path: '/dorm/setting/memers',
    name: 'PageNoJoinAttenceMembers',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageNoJoinAttenceMembers'
      ),
    meta: {
      modular: 4,
      title: '未参与考勤人员',
      info: '学生宿舍——未参与考勤人员'
    }
  },
  {
    path: '/dorm/setting/joinGroup',
    name: 'PageDormJoinGroup',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormJoinGroup'
      ),
    meta: {
      modular: 4,
      title: '选择宿舍考勤组',
      info: '学生宿舍——选择宿舍考勤组'
    }
  },
  {
    path: '/dorm/export',
    name: 'PageDormExport',
    component: () =>
      import(
        /* webpackChunkName: "core-business" */ '../pages/dorm/PageDormExport'
      ),
    meta: { modular: 4, title: '导出考勤数据', info: '学生宿舍——导出考勤数据' }
  }
]
